var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "noselect" },
    [
      _c("v-container", { attrs: { "grid-list-md": "" } }, [
        _c(
          "div",
          { staticClass: "text-center mt-7" },
          [
            _c("h4", [_vm._v("Setup Kiosk System")]),
            _c("div", { staticClass: "spacer-15" }),
            _c("div", [
              _vm._v(" isKiosk: " + _vm._s(_vm.$store.getters.isKiosk) + " "),
            ]),
            _c("div", [
              _vm._v(" table: " + _vm._s(_vm.$store.getters.table) + " "),
            ]),
            _c(
              "div",
              { staticClass: "mt-4" },
              [
                _c(
                  "v-btn",
                  {
                    attrs: { color: "btn-mini" },
                    on: { click: _vm.clickBestellungen },
                  },
                  [_vm._v(" Letzte Bestellungen ")]
                ),
              ],
              1
            ),
            _vm.$store.getters.isKiosk && _vm.$store.getters.isAndroidKiosk
              ? _c("div", { staticClass: "pa-0" }, [
                  _c("div", { staticClass: "superCenter" }, [
                    _c(
                      "div",
                      { staticClass: "d-inline-block myBox" },
                      [
                        _c(
                          "KioskInputWrapper",
                          {
                            model: {
                              value: _vm.androidKioskUrl,
                              callback: function ($$v) {
                                _vm.androidKioskUrl = $$v
                              },
                              expression: "androidKioskUrl",
                            },
                          },
                          [
                            _c("v-text-field", {
                              attrs: {
                                inputmode: "none",
                                "input-props": { inputmode: "none" },
                                label: "Android Kiosk URL",
                                outlined: "",
                                "hide-details": "",
                              },
                              model: {
                                value: _vm.androidKioskUrl,
                                callback: function ($$v) {
                                  _vm.androidKioskUrl = $$v
                                },
                                expression: "androidKioskUrl",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "pt-2 pb-2",
                            staticStyle: {
                              "font-size": "0.8em",
                              "max-width": "800px",
                            },
                          },
                          [
                            _vm._v(
                              " Geladene URL: " + _vm._s(_vm.loadedUrl) + " "
                            ),
                          ]
                        ),
                        _c(
                          "v-btn",
                          {
                            staticClass: "btn-mini",
                            on: { click: _vm.setAndroidKioskUrl },
                          },
                          [_vm._v(" Set ")]
                        ),
                        _c(
                          "v-btn",
                          {
                            staticClass: "btn-mini ml-4",
                            on: { click: _vm.getAndroidKioskUrl },
                          },
                          [_vm._v(" Get ")]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "superCenter" }, [
                    _c("div", { staticClass: "d-inline-block myBox" }, [
                      _c("h3", [_vm._v("Ausgabeparameter")]),
                      _c(
                        "table",
                        { staticClass: "table-collapse configTable" },
                        [
                          _c("tr", [
                            _c(
                              "td",
                              [
                                _c("div", [_vm._v("Bluetooth Devices")]),
                                _c("v-textarea", {
                                  staticClass: "outputTextarea",
                                  attrs: {
                                    "hide-details": "",
                                    readonly: "",
                                    inputmode: "none",
                                    "input-props": { inputmode: "none" },
                                    outlined: "",
                                    rows: "3",
                                    "auto-grow": "",
                                    "font-family": "monospace",
                                    "persistent-hint": "",
                                  },
                                  model: {
                                    value: _vm.bluetoothDevices,
                                    callback: function ($$v) {
                                      _vm.bluetoothDevices = $$v
                                    },
                                    expression: "bluetoothDevices",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "td",
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "btn-mini ml-4",
                                    on: {
                                      click: _vm.getAndroidBluetoothDevices,
                                    },
                                  },
                                  [_vm._v(" Get ")]
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c("tr", [
                            _c(
                              "td",
                              [
                                _c("div", [_vm._v("Softpos Verkaufstellen")]),
                                _c("v-textarea", {
                                  staticClass: "outputTextarea",
                                  attrs: {
                                    "hide-details": "",
                                    readonly: "",
                                    inputmode: "none",
                                    "input-props": { inputmode: "none" },
                                    outlined: "",
                                    rows: "3",
                                    "auto-grow": "",
                                    "font-family": "monospace",
                                    "persistent-hint": "",
                                  },
                                  model: {
                                    value: _vm.allPaymentStores,
                                    callback: function ($$v) {
                                      _vm.allPaymentStores = $$v
                                    },
                                    expression: "allPaymentStores",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "td",
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "btn-mini ml-4",
                                    on: {
                                      click: _vm.getAndroidAllPaymentStores,
                                    },
                                  },
                                  [_vm._v(" Get ")]
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c("tr", [
                            _c(
                              "td",
                              [
                                _c("div", [_vm._v("Softpos Terminal State")]),
                                _c("v-text-field", {
                                  attrs: {
                                    inputmode: "none",
                                    "input-props": { inputmode: "none" },
                                    outlined: "",
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.softposTerminalState,
                                    callback: function ($$v) {
                                      _vm.softposTerminalState = $$v
                                    },
                                    expression: "softposTerminalState",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "td",
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "btn-mini ml-4",
                                    on: { click: _vm.getSoftposTerminalState },
                                  },
                                  [_vm._v(" Get ")]
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c("tr", [
                            _c("td", [
                              _c("div", [_vm._v("Aktiver Store im Terminal")]),
                              _vm.storePicked.storeId
                                ? _c("div", [
                                    _vm._v(
                                      "Name: " +
                                        _vm._s(_vm.storePicked.storeName) +
                                        ","
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      " StoreID: " +
                                        _vm._s(_vm.storePicked.storeId) +
                                        ","
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      " SoftpayAppId: " +
                                        _vm._s(_vm.storePicked.softpayAppId)
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                            _c(
                              "td",
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "btn-mini ml-4",
                                    on: { click: _vm.getStorePicked },
                                  },
                                  [_vm._v(" Get ")]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "superCenter" }, [
                    _c(
                      "div",
                      { staticClass: "d-inline-block myBox" },
                      [
                        _c(
                          "v-container",
                          [
                            _c(
                              "KioskInputWrapper",
                              {
                                model: {
                                  value: _vm.androidJsonAppConfig,
                                  callback: function ($$v) {
                                    _vm.androidJsonAppConfig = $$v
                                  },
                                  expression: "androidJsonAppConfig",
                                },
                              },
                              [
                                _c("v-textarea", {
                                  attrs: {
                                    "hide-details": "",
                                    inputmode: "none",
                                    label: "JSON Application Config",
                                    outlined: "",
                                    rows: "19",
                                    "auto-grow": "",
                                    clearable: "",
                                    "font-family": "monospace",
                                    hint: "Hier kannst du deine Konfiguration bearbeiten",
                                    "persistent-hint": "",
                                  },
                                  model: {
                                    value: _vm.androidJsonAppConfig,
                                    callback: function ($$v) {
                                      _vm.androidJsonAppConfig = $$v
                                    },
                                    expression: "androidJsonAppConfig",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-btn",
                          {
                            staticClass: "btn-mini",
                            on: { click: _vm.setAndroidJsonAppConfig },
                          },
                          [_vm._v(" Set ")]
                        ),
                        _c(
                          "v-btn",
                          {
                            staticClass: "btn-mini ml-4",
                            on: { click: _vm.getAndroidJsonAppConfig },
                          },
                          [_vm._v(" Get ")]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "superCenter" }, [
                    _c(
                      "div",
                      { staticClass: "d-inline-block myBox" },
                      [
                        _c(
                          "v-container",
                          [
                            _c("v-textarea", {
                              attrs: {
                                "hide-details": "",
                                readonly: "",
                                inputmode: "none",
                                "input-props": { inputmode: "none" },
                                label: "Printer Log",
                                outlined: "",
                                rows: "8",
                                "auto-grow": "",
                                "font-family": "monospace",
                                "persistent-hint": "",
                              },
                              model: {
                                value: _vm.printerLog,
                                callback: function ($$v) {
                                  _vm.printerLog = $$v
                                },
                                expression: "printerLog",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-btn",
                          {
                            staticClass: "btn-mini ml-4",
                            on: { click: _vm.getPrinterLog },
                          },
                          [_vm._v(" Get ")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm.$store.getters.isKiosk && !_vm.$store.getters.isAndroidKiosk
              ? _c(
                  "div",
                  [
                    _c("div", { staticClass: "spacer-15" }),
                    _c("div", { staticClass: "superCenter" }, [
                      _c("div", { staticClass: "d-inline-block myBox" }, [
                        _c("h3", [_vm._v("Ausgabeparameter")]),
                        _c(
                          "table",
                          { staticClass: "table-collapse configTable" },
                          [
                            _c("tr", [
                              _c(
                                "td",
                                [
                                  _c("div", [_vm._v("Bluetooth Devices")]),
                                  _c("v-textarea", {
                                    staticClass: "outputTextarea",
                                    attrs: {
                                      "hide-details": "",
                                      readonly: "",
                                      inputmode: "none",
                                      "input-props": { inputmode: "none" },
                                      outlined: "",
                                      rows: "3",
                                      "auto-grow": "",
                                      "font-family": "monospace",
                                      "persistent-hint": "",
                                    },
                                    model: {
                                      value: _vm.bluetoothDevices,
                                      callback: function ($$v) {
                                        _vm.bluetoothDevices = $$v
                                      },
                                      expression: "bluetoothDevices",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "td",
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "btn-mini ml-4",
                                      on: {
                                        click: _vm.getWindowsBluetoothDevices,
                                      },
                                    },
                                    [_vm._v(" Get ")]
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "superCenter" }, [
                      _c(
                        "div",
                        { staticClass: "d-inline-block myBox" },
                        [
                          _c(
                            "v-container",
                            [
                              _c("v-textarea", {
                                attrs: {
                                  "hide-details": "",
                                  readonly: "",
                                  inputmode: "none",
                                  "input-props": { inputmode: "none" },
                                  label: "Printer Log",
                                  outlined: "",
                                  rows: "8",
                                  "auto-grow": "",
                                  "font-family": "monospace",
                                  "persistent-hint": "",
                                },
                                model: {
                                  value: _vm.printerLog,
                                  callback: function ($$v) {
                                    _vm.printerLog = $$v
                                  },
                                  expression: "printerLog",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn-mini ml-4",
                              on: { click: _vm.getPrinterLog },
                            },
                            [_vm._v(" Get ")]
                          ),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "superCenter" }, [
                      _c("div", { staticClass: "d-inline-block myBox" }, [
                        _c("h3", [_vm._v("Output Params:")]),
                        _c("div", [
                          _vm._v(
                            "Last Update: " + _vm._s(_vm.lastUpdateOutputParams)
                          ),
                        ]),
                        _c("div", { staticStyle: { "white-space": "pre" } }, [
                          _vm._v(_vm._s(_vm.paramsString)),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "superCenter" }, [
                      _c("div", { staticClass: "d-inline-block myBox" }, [
                        _c(
                          "div",
                          { staticClass: "flex" },
                          [
                            _c("h3", [_vm._v("All Params:")]),
                            _c("v-spacer"),
                            _c(
                              "v-btn",
                              {
                                staticClass: "btn-mini",
                                on: { click: _vm.readAllParams },
                              },
                              [_vm._v("Refresh ")]
                            ),
                          ],
                          1
                        ),
                        _c("div", { staticStyle: { "white-space": "pre" } }, [
                          _vm._v(_vm._s(_vm.allParamsString)),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "superCenter" }, [
                      _c(
                        "div",
                        { staticClass: "d-inline-block myBox" },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Betrag (inkl. Trinkgeld)",
                              type: "number",
                              step: "0.01",
                              rules: [_vm.validateDouble],
                              outlined: "",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.doubleValue,
                              callback: function ($$v) {
                                _vm.doubleValue = $$v
                              },
                              expression: "doubleValue",
                            },
                          }),
                          _c("v-text-field", {
                            attrs: {
                              label: "Trinkgeld (optional)",
                              type: "number",
                              step: "0.01",
                              rules: [_vm.validateDouble],
                              outlined: "",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.doubleTrinkgeld,
                              callback: function ($$v) {
                                _vm.doubleTrinkgeld = $$v
                              },
                              expression: "doubleTrinkgeld",
                            },
                          }),
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "btn-df" },
                              on: { click: _vm.triggerTerminalPayment },
                            },
                            [_vm._v(" Trigger Payment ")]
                          ),
                        ],
                        1
                      ),
                    ]),
                    _c(
                      "v-btn",
                      {
                        attrs: { color: "btn-df" },
                        on: { click: _vm.checkTerminalServiceActive },
                      },
                      [_vm._v(" Check Terminal Service active ")]
                    ),
                    _c("div", { staticClass: "spacer-15" }),
                    _c(
                      "v-btn",
                      {
                        attrs: { color: "btn-df" },
                        on: { click: _vm.getCurrentTerminalIp },
                      },
                      [_vm._v(" Get current terminal IP ")]
                    ),
                    _c("div", { staticClass: "spacer-15" }),
                    _c(
                      "v-btn",
                      {
                        attrs: { color: "btn-df" },
                        on: { click: _vm.clickTriggerDiagnose },
                      },
                      [_vm._v(" Trigger Diagnose ")]
                    ),
                    _c("div", { staticClass: "spacer-15" }),
                    _c(
                      "v-btn",
                      {
                        attrs: { color: "btn-df" },
                        on: { click: _vm.finishSetup },
                      },
                      [_vm._v(" Finish Setup and Open Start Page ")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "spacer-20" }),
            _c(
              "div",
              { staticClass: "mb-4" },
              [
                _c(
                  "v-btn",
                  {
                    attrs: { color: "btn-mini" },
                    on: { click: _vm.clickDebugParams },
                  },
                  [_vm._v(" Öffne Konfigurationsparameter ")]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "mb-4" },
              [
                _c(
                  "v-btn",
                  {
                    attrs: { color: "btn-mini" },
                    on: { click: _vm.clickSetupShowHide },
                  },
                  [_vm._v(" Setup Button aus/einblenden ")]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "mb-4" },
              [
                _c(
                  "v-btn",
                  {
                    attrs: { color: "btn-mini" },
                    on: { click: _vm.releaseTerminal },
                  },
                  [_vm._v(" Release Terminal ")]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "mb-4" },
              [
                _c(
                  "v-btn",
                  {
                    attrs: { color: "btn-mini" },
                    on: { click: _vm.dummyPrint },
                  },
                  [_vm._v(" Print Dummy Page ")]
                ),
              ],
              1
            ),
            _c("div", { staticClass: "spacer-40" }),
            _c(
              "v-btn",
              { attrs: { color: "btn-mini" }, on: { click: _vm.exitKiosk } },
              [_vm._v(" Exit Kiosk Mode ")]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }